/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 13:36:37
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 17:53:30
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/TermsAndConditionEditor/PageSetting/index.tsx
 */
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import React from 'react';
//import css from './css.module.less';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { TextArea } from 'src/components/Antd';
import Input from 'src/constrains/DebounceRequestInput';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionHOC from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/HOC';
import {
  EnumCollapseId,
  getCollapse,
  getPageSetting,
  onCollapseChange,
  onPageSettingChange,
} from 'src/pages/SalesCannelVersion/SalesChannelLegal/TermsAndConditionEditor/slice';
import { postCheckTCName } from 'src/request/salesChannel/legal';
import { NEW } from 'src/tools/constant';
import { generateErrorKey } from 'src/tools/helper';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import { tacPermissions } from '../../Components/hooks/permission';

const _postCheckLegalName = (body) => {
  return postCheckTCName(body, {
    [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  });
};

const PageSetting = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _data: any = useSelector(getPageSetting());
  const _d = useDispatch();
  const p: any = useParams();

  const { TcUuid, uuid } = p;
  const { canEdit } = tacPermissions(uuid);
  const isNew = TcUuid == NEW;
  const fixedParams = {
    salesChannelUuid: uuid,
    uuid: isNew ? null : TcUuid,
  };
  const {
    name, //isNameDuplicate
    remarks,
    nameIsValid,
  } = _data || {};
  const nameError = _data[generateErrorKey('name')];

  const handleOnNameChange = ({ text, valid }) => {
    _d(onPageSettingChange({ name: text, nameIsValid: valid }));
  };

  const handleOnRemarksChange = (remarks) => {
    _d(onPageSettingChange({ remarks }));
  };
  return (
    <SectionContent>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                rightPart={
                  <CountWords count={(name || '').length} allCount={100} />
                }
                title={`${getI18n(
                  'termsAndCondition.index.termsConditionsName',
                )}*`}
                id='SalesChannelLegalTermsAndConditionEditorPageName'>
                <Input
                  customError={nameError}
                  customHelper={getI18n(
                    'termsAndCondition.index.termsConditionsNamecustomHelper',
                  )}
                  invalidHelper={getI18n(
                    'termsAndCondition.index.termsConditionsNameinvalidHelper',
                  )}
                  displayDangerousNotice={true}
                  maxLength={100}
                  onChange={handleOnNameChange}
                  value={name}
                  isValid={nameIsValid}
                  size='large'
                  checkFunction={_postCheckLegalName}
                  fixedParams={fixedParams}
                  disabled={!canEdit || props?.disabled}
                />
              </ItemWrapper>
            ),
          },
          {
            child: (
              <ItemWrapper
                title={getI18n('general.remarks')}
                rightPart={
                  <CountWords count={(remarks || '').length} allCount={500} />
                }>
                <TextArea
                  maxLength={500}
                  onChange={handleOnRemarksChange}
                  value={remarks}
                  autoSize={{ minRows: 1, maxRows: 5 }}
                  placeholder={getI18n('general.remarks')}
                  disabled={!canEdit || props?.disabled}
                />
              </ItemWrapper>
            ),
          },
          //,
        ]}
      />
    </SectionContent>
  );
};

export default SectionHOC(PageSetting, {
  id: EnumCollapseId.PageSetting,
  title: getI18nFromGeneral('general.hOCTitle.termsConditionsSetting'),
  getCollapse,
  onCollapseChange,
  cannotCollapse: true,
});
